import React, {useEffect, useState} from "react";
import clsx from "clsx";


export type LoadingProps = {
  loadingText: string | null;
  className?: string;
}

export default function Loading({loadingText, className}: LoadingProps) {
  const [showLoading, setShowLoading] = useState(false);

  useEffect(() => {
    if (showLoading) return;

    const timeoutId = setTimeout(() => {
      setShowLoading(true);
    }, 333);
    return (() => clearTimeout(timeoutId));
  }, [showLoading]);

  return showLoading && <div className={clsx(
      "flex flex-col justify-center",
      className
  )}>
    <div className={"flex justify-center"}>
      <img src={"/branding-compass-loading.gif"} alt="loading spinner" />
    </div>
    <div className={"flex justify-center mt-4"}>
      <span className={"text-neutral-200"}>{loadingText}</span>
    </div>
  </div> || null;
}
